import moment    from 'moment';
import UtilsData from '@/utilities/UtilsData';

export default {

  round(data, num = 5) {
    return Number.parseFloat(data).toFixed(num);
  },

  roundValues(data, roundFieldsNames, num = 5) {
    for (let roundFieldsName of roundFieldsNames) {
      const value = data[roundFieldsName];
      if (value == null || value === 'NaN' || typeof value !== 'number') {
        data[roundFieldsName] = 0.0;
      } else {
        data[roundFieldsName] = this.round(value, num);
      }
    }
  },

  formatAsNumber(value, singsAfterDot = 0) {
    if (value?.endsWith && value.endsWith('.')) {
      value = `${value}0`;
    }
    let minFractionDigits = 0;
    let maxFractionDigits = minFractionDigits;
    if (typeof singsAfterDot === 'number') {
      minFractionDigits = singsAfterDot;
      maxFractionDigits = singsAfterDot;
    } else {
      ({ minSignsAfterDot: minFractionDigits = 0, maxSignsAfterDot: maxFractionDigits = 0 } = singsAfterDot);
    }
    let res = UtilsData.castToNumber(value, maxFractionDigits);
    if (res === null) return null;
    res = Number(res).toLocaleString('us-US', { minimumFractionDigits: minFractionDigits, maximumFractionDigits: maxFractionDigits });
    return res;
  },

  formatDollarValue(data, decimalPlaces = 2) {
    if (typeof data === 'string' || data instanceof String) {
      if (data === 'NaN') {
        data = undefined
      } else {
        data = data.replace(/,/g, '');
      }
    }
    return (data != null)
      ? new Intl.NumberFormat('us-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces }).format(data)
      : '';
  },

  formatDollarValues(data, dollarFieldsNames, decimalPlaces = 2) {
    for (var dollarFieldName of dollarFieldsNames) {
      data[dollarFieldName] = this.formatDollarValue(data[dollarFieldName], decimalPlaces);
    }
    return data;
  },

  formatPercentValue(data, decimalPlaces = 2) {
    let res = '';
    if (typeof data === 'string' || data instanceof String) {
      if (data === 'NaN') {
        data = undefined
      } else {
        data = data.replace(/,/g, '');
      }
    }
    if (data != null) {
      let protoRes = data * 100;
      protoRes     = new Intl.NumberFormat('us-US', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces }).format(protoRes);
      res          = `${protoRes} %`;
    }
    return res;
  },

  formatPctValue(value, decimalPlaces = 5) {
    if (value == null || value === 'NaN' || typeof value !== 'number') {
      return '';
    }
    const roundedValue = this.round(value * 100, decimalPlaces);
    return Number.isNaN(roundedValue) ? '' : `${roundedValue}%`;
  },

  formatPctValueWithoutRounding(value) {
    if (value == null || value === 'NaN' || typeof value !== 'number') {
      return '';
    }
    return `${value * 100.0}%`;
  },

  formatPctValues(data, pctFieldsNames) {
    for (var pctFieldsName of pctFieldsNames) {
      data[pctFieldsName] = this.formatPctValue(data[pctFieldsName]);
    }
    return data;
  },

  formatDateString(strDate, toFormat = 'MM/DD/YYYY') {
    return typeof strDate !== 'undefined' ? moment(strDate).format(toFormat) : '';
  },

  formatDateValue(date, format = 'MM/DD/YYYY') {
    return typeof date !== 'undefined' ? moment(date, 'YYYYMMDD').format(format) : '';
  },

  formatDateValues(data, dateFieldsNames, format = 'MM/DD/YYYY') {
    for (let dateFieldsName of dateFieldsNames) {
      data[dateFieldsName] = this.formatDateValue(data[dateFieldsName], format);
    }
    return data;
  },

  formatDashesIfNeeded(data) {
    return data != null ? data : '-----'
  },

  formatDatesInArray(arr, dateFieldsNames = [], format = 'MM/DD/YYYY') {
    for (var row of arr) {
      row = this.formatDateValues(row, dateFieldsNames, format);
    }
    return arr;
  },

  formatDataInArray(arr, dollarFieldsNames, dateFieldsNames = [], pctFieldsNames = [], roundFieldsNames = []) {
    for (var row of arr) {
      row = this.formatDollarValues(row, dollarFieldsNames);
      row = this.formatDateValues(row, dateFieldsNames);
      row = this.formatPctValues(row, pctFieldsNames);
      row = this.roundValues(row, roundFieldsNames);
    }
    return arr;
  },

  formatAsYYYYMMDD(date) {
    return moment(date)
      .format()
      .split('T')[0]
      .replace(/-/g, '')
  },

  formatAsYYYYMM(date) {
    return moment(date)
      .format('YYYYMM')
      .split('T')[0]
      .replace(/-/g, '')
  }
}
